// src/pages/CategoryPage.js
import React, { useEffect, useState, lazy, Suspense, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Modal from 'react-bootstrap/Modal';
import '../style/querocomprar.css';
import MenuPrincipal from "../components/menuPrincipal";
import WhatsApp from "../components/whatsApp";
import LoadingOverlay from "../components/loading";
import { fetchCategories2 } from '../redux/reducers/categoriesSlice';
import { fetchProducts, filterProduct, fetchFilteredProducts, fetchAllProducts } from '../redux/reducers/produtoSlice';
import { addProductToCart } from '../redux/reducers/cartSlice';
import PaginationComponent from '../components/paginacao';
import { scrollToTop } from '../util';
const BASE_URL = process.env.REACT_APP_BASE_URL
const Rodape = lazy(() => import('../components/rodape'));
const Seo = lazy(() => import('../components/SEO'));

const CategoryPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { typesApi2 } = useSelector((state) => state.categories);
    const [activeTheme, setActiveTheme] = useState('all'); // "all" como padrão para "Todos"
    const [showModal, setShowModal] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const [seoUrl, setSeoUrl] = useState(window.location.href);
    const [selectedFilters, setSelectedFilters] = useState({
        modelos: [],    // Array para armazenar os IDs de modelos selecionados
        atributos: []   // Array para armazenar os IDs de atributos selecionados
    });
    //console.log(typesApi2,'typesApi2')
    const topRef = useRef(null);
    
    const [showMore, setShowMore] = useState({});
    const [selectProdCar, setSelectProdCar] = useState();
    const { products, totalPage, loading4, filter, modelos } = useSelector((state) => state.produtos);
    //console.log(useSelector((state) => state.produtos), 'useSelector((state) => state.produtos)')
    //Paginação
    // console.log('products', products);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 9; // Define quantos itens serão exibidos por página
    const totalPages = Math.ceil(totalPage / itemsPerPage);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };
    const toggleFilters = () => {
        setShowFilters(!showFilters);
    }
    const toggleShowMore = (attributeName) => {
        setShowMore((prevState) => ({
            ...prevState,
            [attributeName]: !prevState[attributeName],
        }));
    };

    const handleThemeClick = (theme) => {
        setActiveTheme(theme.id);
        setSelectedFilters({ modelos: [], atributos: [] })
        dispatch(filterProduct(theme.id));
    };

    const handleAllProducts = () => {
        setActiveTheme('all'); // Define "all" como o tema ativo
        setSelectedFilters({ modelos: [], atributos: [] })
        dispatch(fetchAllProducts(currentPage)); // Despacha a ação para buscar todos os produtos
    };

    const handleFilterChange = (filterType, value, isChecked) => {
        setSelectedFilters((prevFilters) => {
            // Cria uma cópia do estado anterior
            const updatedFilters = { ...prevFilters };
            // Garantir que os arrays existam antes de tentar manipular
            if (!updatedFilters.modelos) updatedFilters.modelos = [];
            if (!updatedFilters.atributos) updatedFilters.atributos = [];
            // Atualiza o array correto (modelos ou atributos) com base no `filterType`
            if (filterType === 'modelo') {
                if (isChecked) {
                    updatedFilters.modelos.push(value);  // Adiciona o valor ao array de modelos
                } else {
                    updatedFilters.modelos = updatedFilters.modelos.filter((item) => item !== value);  // Remove o valor
                }
            } else if (filterType === 'atributo') {
                if (isChecked) {
                    updatedFilters.atributos.push(value);  // Adiciona o valor ao array de atributos
                } else {
                    updatedFilters.atributos = updatedFilters.atributos.filter((item) => item !== value);  // Remove o valor
                }
            }
            // Retorna o estado atualizado
            return updatedFilters;
        });
    };

    const handleAddToCart = (product) => {
        dispatch(addProductToCart(product));
        setShowModal(true);
        setSelectProdCar(product)
    };

    const applyFilters = () => {
        scrollToTop(topRef)
        setShowFilters(false); // Fecha os filtros após aplicar
        // Verifica se há filtros selecionados
        if (activeTheme === 'all') {
            dispatch(fetchFilteredProducts({ filters: selectedFilters })); // Busca com todos os filtros
        } else {
            dispatch(fetchFilteredProducts({ filters: selectedFilters, typeId: activeTheme }));
        }
    };

    const handleClearFilters = () => {
        setSelectedFilters({ modelos: [], atributos: [] });
        setActiveTheme('all');
        dispatch(fetchAllProducts(currentPage));
        setShowFilters(false); // Fecha os filtros após aplicar
        scrollToTop(topRef)
    };

    const formatProductName = (name) => {
        return name
            .normalize("NFD") // Normaliza para decompor acentos
            .replace(/[\u0300-\u036f]/g, "") // Remove acentos
            .replace(/\s+/g, '-') // Substitui espaços por hifens
            .toLowerCase();
    };

    const handleViewDetails = (sku, nome) => {
        const formattedName = formatProductName(nome);
        navigate(`/produto/${sku}/${formattedName}`);
    };

    const getIconClassForAttribute = (attributeName) => {
        // Lista de mapeamento de atributos para classes de ícones
        const attributeIconMap = {
            'bateria': 'fa-solid fa-battery-full',
            'câmera': 'fa-solid fa-camera',
            'memória': 'fa-solid fa-memory',
            'conectividade': 'fa-solid fa-wifi',
            'bluetooth': 'fa-solid fa-bluetooth',
            'tela': 'fa-solid fa-mobile-alt',
            'processador': 'fa-solid fa-cogs',
            'cores': 'fa-solid fa-palette',
            'carregador': 'fa-solid fa-plug',
            'carregamento': 'fa-solid fa-plug-circle-exclamation',
            'acessórios': 'fa-solid fa-box-open',
            'capacidade': 'fa-solid fa-hdd',
            'sistema operacional': 'fa-brands fa-android', // ou 'fa-brands fa-apple' para iOS
            'resolução': 'fa-solid fa-expand',
            'peso': 'fa-solid fa-weight',
            'dimensões': 'fa-solid fa-ruler-combined',
            'sensor': 'fa-solid fa-fingerprint',
            'frequência': 'fa-solid fa-signal',
            'áudio': 'fa-solid fa-headphones-alt',
            'material': 'fa-solid fa-boxes',
            'garantia': 'fa-solid fa-shield-alt',
            'dual sim': 'fa-solid fa-sim-card',
            'resistência à água': 'fa-solid fa-water',
            // Adicione outros atributos conforme necessário
        };
        // Formata o nome do atributo para buscar no mapa (converte para minúsculas)
        const key = attributeName.toLowerCase();
        // Retorna a classe correspondente ou uma classe padrão
        return attributeIconMap[key] || 'fa-solid fa-check';
    };

    useEffect(() => {
        dispatch(fetchCategories2()); // Busca os dados ao montar o componente
        handleAllProducts();
        setSeoUrl(window.location.href);
    }, [dispatch, currentPage]);

    useEffect(() => {
        if (activeTheme != 'all') {
            dispatch(fetchProducts());
            dispatch(filterProduct(typesApi2[0]?.id));
        }
    }, [dispatch, typesApi2]);

    return (
        <div>
            <Suspense >
                <Seo
                    title="Venda e Compra de iPhones em Blumenau | Pentalobe"
                    description="Venda seu iPhone de forma rápida e segura em Blumenau! Avaliação justa e pagamento imediato. Clique e saiba mais sobre como vender seu iPhone conosco!"
                    keywords={products?.data?.length > 0 ? products?.data?.map(p => p.name).join(', ') : ''}
                    url={seoUrl}
                    type="website"
                />
            </Suspense>
            <MenuPrincipal />
            {/* Filtros e Ordenação */}
            <div className={`box-2 loading ${loading4 ? 'loading-active' : ''}`}>
                <LoadingOverlay loading={loading4} />
                <div className="section-spacing-3" >
                    <Container style={{
                        borderBottom: '2px solid transparent',
                        backgroundImage: 'linear-gradient(to right, #ff7e00, rgba(255,126,0,0))',
                        backgroundPosition: 'bottom',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: '100% 2px'
                    }}>
                        <div className='nav2'>
                            <Nav className="theme-menu d-flex justify-content-between align-items-center">
                                {/* Adiciona a opção "Todos" no menu */}
                                <Nav.Item className="theme-item">
                                    <div
                                        className={`theme-link ${activeTheme === 'all' ? 'active' : ''}`}
                                        onClick={handleAllProducts}
                                        role="button"
                                    >
                                        {/*<img src={iconeTodos} alt="ícone" className='icone-iphone' />*/}
                                        Todos
                                    </div>
                                </Nav.Item>
                                {/* Mapeia os temas disponíveis */}
                                {typesApi2?.map((theme) => (
                                    <Nav.Item key={theme.id} className="theme-item">
                                        <div
                                            className={`theme-link ${activeTheme === theme.id ? 'active' : ''}`}
                                            onClick={() => handleThemeClick(theme)}
                                            role="button"
                                        >
                                            {theme.name}
                                        </div>
                                    </Nav.Item>
                                ))}
                            </Nav>
                        </div>
                    </Container>
                </div>
                <section className='section-spacing-4' ref={topRef}>
                    <Row className="mb-4 d-flex justify-content-center" >
                        <Col lg={3} md={4} className='filtros-cell'>
                            <h4 className="filter-toggle" onClick={toggleFilters} ><i class="fa-solid fa-sliders"></i> Filtros</h4>
                            <Form className={`form-filter ${showFilters ? 'show' : 'hide'}`}>
                                {/*<Form.Group className="mb-3">
                                    <Form.Label>Marca</Form.Label>
                                    <Form.Select>
                                        <option>Todas</option>
                                        <option>Samsung</option>
                                    </Form.Select>
                                </Form.Group>*/}

                                {/*<Form.Group className="mb-3">
                                    <Form.Label>Preço</Form.Label>
                                    <Form.Range />
                                    <div className="price-range">
                                        <span>R$500</span> - <span>R$5000</span>
                                    </div>
                                </Form.Group>*/}
                                <div className='filter-container'>
                                    <Form.Group className="mb-3">
                                        <Form.Label><i style={{ color: '#ff751a' }} class="fa-solid fa-bars-staggered"></i> Modelos</Form.Label>
                                        {modelos.map((item2) => (
                                            <Form.Check
                                                type="checkbox"
                                                label={item2.name}
                                                key={item2.id}
                                                checked={(selectedFilters.modelos || []).includes(item2.id)} // ⬅️ Blindagem correta
                                                onChange={(e) => handleFilterChange('modelo', item2.id, e.target.checked)}
                                            />
                                        ))}
                                    </Form.Group>
                                    {/* Seção de filtros dinâmicos */}
                                    {filter?.map((item) => (
                                        <Form.Group className="mb-3" key={item.name}>
                                            <Form.Label><i style={{ color: '#ff751a' }} className={getIconClassForAttribute(item.name)}></i> {item.name}</Form.Label>
                                            {/* Exibe apenas os primeiros 10 itens ou todos, dependendo do estado showMore */}
                                            {item.attribute_values.slice(0, showMore[item.name] ? item.attribute_values.length : 10).map((item2) => (
                                                <Form.Check
                                                    type="checkbox"
                                                    label={item2.value}
                                                    key={item2.id}
                                                    checked={selectedFilters.atributos.includes(item2.id)}
                                                    onChange={(e) => handleFilterChange('atributo', item2.id, e.target.checked)}
                                                />
                                            ))}

                                            {/* Botão de "Veja mais" para atributos com mais de 10 valores */}
                                            {item.attribute_values.length > 10 && (
                                                <Button
                                                    variant="link"
                                                    onClick={() => toggleShowMore(item.name)}
                                                    className={`see-more-btn ${showMore[item.name] ? 'rotated' : ''}`}
                                                >
                                                    {showMore[item.name] ? 'Veja menos' : 'Veja mais'}
                                                    <i class="fa-solid fa-angle-down icone"></i>
                                                </Button>
                                            )}
                                        </Form.Group>
                                    ))}
                                </div>
                                <div className="d-flex gap-3 mb-3 mt-3 align-items-center justify-content-center">
                                    <Button variant="primary" onClick={applyFilters} style={{ fontSize: '13px' }}>
                                        Aplicar Filtros
                                    </Button>
                                    <Button variant="secondary" onClick={handleClearFilters} style={{ fontSize: '13px' }}>
                                        Limpar Filtros
                                    </Button>
                                </div>
                                {/*<Button variant="primary" className="w-100" onClick={applyFilters}>Aplicar Filtros</Button>*/}
                            </Form>
                        </Col>
                        {/* Produtos e Ordenação */}
                        <Col xs={12} lg={9} md={8}>
                            {/*<div className="d-flex justify-content-between align-items-center mb-3">
                                <Form.Select className="w-auto">
                                    <option>Ordenar por</option>
                                    <option>Melhor Avaliação</option>
                                    <option>Menor Preço</option>
                                    <option>Maior Preço</option>
                                </Form.Select>
                            </div>*/}
                            {/* Lista de Produtos */}
                            <div className='d-flex justify-content-center'>
                                {activeTheme === 'all' && (
                                    <PaginationComponent
                                        currentPage={currentPage}
                                        lastPage={totalPages}
                                        onPageChange={handlePageChange}
                                    />
                                )}
                            </div>
                            {products?.data?.length === 0 && !loading4 ? (
                                <div className="text-center my-5  d-flex align-items-center justify-content-center" >
                                    <div style={{ width: '40%' }} className='shadow-lg p-3 mb-5 bg-white rounded'>
                                        <svg width="100" height="100" viewBox="0 0 24 24" fill="none">
                                            <circle cx="11" cy="11" r="7" stroke="#ff751a" strokeWidth="2" />
                                            <line x1="16.65" y1="16.65" x2="21" y2="21" stroke="#ff751a" strokeWidth="2" />
                                            <line x1="8" y1="8" x2="14" y2="14" stroke="#ff751a" strokeWidth="2" />
                                            <line x1="14" y1="8" x2="8" y2="14" stroke="#ff751a" strokeWidth="2" />
                                        </svg>
                                        <h4 className="mt-3">Nenhum produto encontrado</h4>
                                        <p>Tente ajustar os filtros ou selecione outro tipo.</p>
                                    </div>
                                </div>
                            ) : (
                                <Row >
                                    {products?.data?.map((product) => (
                                        <Col xs={12} md={12} lg={4} key={product} className='card-space mb-4'>
                                            <Card className="product-card h-100  position-relative">
                                                {/* Grupo de Tags */}
                                                <div className="badge-group">
                                                    {product.stock === 0 && (
                                                        <span className="badge-2 out-of-stock">Produto Esgotado</span>
                                                    )}

                                                    {product.selected_attributes?.filter((attr) => attr.name === 'Estado')
                                                        .slice(0, 1)
                                                        .map((attr) => (
                                                            <span className="badge-2">
                                                                <i className="fa-solid fa-award" style={{ fontSize: '1.2em', paddingRight: '10px' }}></i>
                                                                {attr.selected_attribute_values.map((value) => value.value).join(' - ')}
                                                            </span>
                                                        ))}
                                                </div>
                                                <Card.Img
                                                    variant="top"
                                                    onClick={() => handleViewDetails(product.SKU, product.name)}
                                                    src={
                                                        product.images && product.images[0]?.url
                                                            ? product.images[0].url.startsWith("data:image") // Verifica se é base64
                                                                ? product.images[0].url // Base64
                                                                : `${BASE_URL}storage/${product.images[0].url}` // Caminho no servidor
                                                            : "default-image-path" // Caminho para uma imagem padrão
                                                    }
                                                    alt="Produto"
                                                    className="product-img"
                                                />
                                                <Card.Body className="d-flex flex-column info-card">
                                                    <Card.Title className="product-title">{product.name}</Card.Title>
                                                    <Card.Text className="product-price">{Number(product.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</Card.Text>
                                                    <div className="button-group mt-auto">
                                                        <Button
                                                            variant="primary"
                                                            onClick={() => handleAddToCart(product)}
                                                            className="btn-buy-2 mt-3"
                                                            disabled={product.stock === 0}
                                                        >
                                                            Comprar
                                                        </Button>
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    ))}
                                </Row>
                            )}
                        </Col>
                    </Row>
                </section>
            </div>
            <Modal show={showModal} onClick={() => setShowModal(false)} centered className="custom-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Já adicionamos seu produto no carrinho</Modal.Title>
                </Modal.Header>
                <Modal.Body className="d-flex flex-column align-items-center">
                    <img
                        alt={selectProdCar?.name}
                        className="product-image mb-3"
                        style={{ maxWidth: '150px' }}
                        src={
                            selectProdCar?.images[0]?.url
                                ? selectProdCar.images[0].url.startsWith("data:image") // Verifica se é base64
                                    ? selectProdCar.images[0].url // Base64
                                    : `${BASE_URL}storage/${selectProdCar.images[0].url}` // Caminho no servidor
                                : "default-image-path" // Caminho para uma imagem padrão
                        }
                    />

                    <h5>{selectProdCar?.name}</h5>
                    <p className="text-muted">
                        {Number(selectProdCar?.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => window.location.href = '/carrinho'}>
                        Ir para o Carrinho
                    </Button>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Continuar Comprando
                    </Button>
                </Modal.Footer>
            </Modal>
            <Suspense>
                <Rodape />
            </Suspense>
            <WhatsApp classe={'whatsapp-componente-flutuante outra-posicao'} />
        </div>
    );
};

export default CategoryPage;
